import React, { useRef } from 'react'
import {
  Image,
  IcoMoon,
  CancelIcon,
  CameraIconWMO,
} from '@usap/uicomponents'
import { ImageUploadContainer, ImageUploadBox, PhotoLabel } from "../style/ImageUploadWMO.css"

const ImageUploadWMO = props => {
  const {
    attr,
    widgets,
    onChange,
    formFile,
    defaultImage,
    removeImage,
    selectedPart,
    isDesktop,
    required,
  } = props

  const file = useRef(null)

  return (
    <ImageUploadContainer>
      {formFile[attr.id] && (
        <>
          <Image
            width='88px'
            height='88px'
            className="lazyload"
            src={formFile[attr.id] ? formFile[attr.id].file : defaultImage}
            fit="cover"
            onClick={() => {
              file.current.click()
            }}
            cloudinaryParams="h_210,w_210"
            style={{
              alignSelf: 'center',
              borderRadius: "4px",
              cursor: 'pointer',
              minHeight: "88px"
            }}
          />
          <IcoMoon
            icon={CancelIcon}
            color="#FFF"
            size="small"
            onClick={() => removeImage(attr.id, widgets, selectedPart)}
            style={{
              position: 'absolute',
              top: '0',
              right: '0',
              cursor: 'pointer',
            }}
          />
          <input
            accept=".jpg, .jpeg, .gif, .png, .bmp"
            ref={file}
            onChange={onChange}
            name={selectedPart}
            widgetreq={required ? 'true' : ''}
            id={attr.id}
            type="file"
            style={{ visibility: 'hidden', width: '1px', height: '1px' }}
          />
        </>
      )}

      {!formFile[attr.id] && (
        <>
          <input
            accept=".jpg, .jpeg, .gif, .png, .bmp"
            ref={file}
            onChange={onChange}
            name={selectedPart}
            widgetreq={required ? 'true' : ''}
            id={attr.id}
            type="file"
            style={{ visibility: 'hidden', width: '1px', height: '1px' }}
          />
          <ImageUploadBox
            onClick={() => {
              file.current.click()
            }}
          >
            <CameraIconWMO />
          </ImageUploadBox>
        </>
      )}
      <PhotoLabel>
        {attr.label}
      </PhotoLabel>
    </ImageUploadContainer>
  )
}

export default ImageUploadWMO
